import React from "react";
import { Link, useParams } from "react-router-dom";
import { Tab, Tabs, Button } from "react-bootstrap";
import { useSelector } from "react-redux";


import After14Days from "./After14Days";
import Th11To13thWeek from "./Th11To13thWeek";
import Th18to20Weeks from "./Th18-20Weeks";
import Weeks24 from "./Weeks24";
import FertilizationRate from "./Fertilization_rate";

function IVF() {

    const { sample_id } = useParams();
    const sampleCode = useSelector((state) => state.sample.code);
const encodedSampleId = encodeURIComponent(sample_id);
    const tabsStyle = {
        display: "flex",
        justifyContent: "left",
        gap: "5px",
        marginTop: "18px",
        marginBottom: "8px", fontSize: "12px",
        borderBottom: "1px solid #a6a680ff",
    };

    const tabContentStyle = {
        padding: "10px",
        minHeight: "30vh",
    };

    return (
        <div className="text-center" style={{ position: "relative", minHeight: "80vh" }}>



            <div
                className="d-flex align-items-center justify-content-between"

            >
                {/* Label */}
                <p className="mb-0 fw-bold">Clinical Pregnancy data IVF</p>
                <div className="floating-label">
                    {sampleCode}
                </div>

                {/* Buttons */}
                <div className="d-flex gap-3">
                    <Link to={`/molecular-profile/${encodedSampleId}`} className="text-decoration-none">
                        <Button variant="warning" style={{ fontWeight: 600 }} size="sm">
                            Molecular Profile
                        </Button>
                    </Link>

                    <Link to={`/Update_Male_Details/${encodedSampleId}`} className="text-decoration-none">
                        <Button variant="warning" style={{ fontWeight: 600 }} size="sm">
                            Partner Details
                        </Button>
                    </Link>
                    <Link to={`/Follow-Up-Data/${encodedSampleId}`} className="text-decoration-none">
                        <Button variant="primary" size="sm">
                            Previous
                        </Button>
                    </Link>
                </div>
            </div>


            <Tabs defaultActiveKey="After14Days" id="IVF" className="mb-3" style={tabsStyle}>



                <Tab
                    eventKey="After14Days"
                    title="After 14 Days"
                >
                    <div style={tabContentStyle}>
                        <After14Days source="IVF" sampleId={sample_id} />
                    </div>
                </Tab>
                <Tab
                    eventKey="Th11To13thWeek"
                    title={
                        <>
                            11<sup>th</sup> to 13<sup>th</sup> week
                        </>
                    }
                >
                    <div style={tabContentStyle}>
                        <Th11To13thWeek source="IVF" sampleId={sample_id} />
                    </div>
                </Tab>
                <Tab
                    eventKey="Th18to20Weeks"
                    title={<>18<sup>th</sup>to 20<sup>th</sup>weeks</>}
                >
                    <div style={tabContentStyle}>
                        <Th18to20Weeks source="IVF" sampleId={sample_id} />
                    </div>
                </Tab>
                <Tab
                    eventKey="Weeks24"
                    title="24 Weeks"
                >
                    <div style={tabContentStyle}>
                        <Weeks24 source="IVF" sampleId={sample_id} />
                    </div>
                </Tab>
                <Tab
                    eventKey="FertilizationRate"
                    title="Fertilization Rate"
                >
                    <div style={tabContentStyle}>
                        <FertilizationRate source="IVF" sampleId={sample_id} />
                    </div>
                </Tab>


            </Tabs>
            <style>{`
       

                
.floating-label {
  position: fixed;
  top: 50%;
  left: 1px;
  transform: translateY(-50%);

  background: linear-gradient(
    180deg,
    #ff5C4D   /* soft medical blue */ 
    
  ); 

  color: #3333BB;
   font-family: "Poppins", "Montserrat", "Segoe UI", sans-serif;
  padding: 14px 16px;
  border-radius: 10px;

  box-shadow:
    0 10px 25px rgba(30, 64, 175, 0.35),
    inset 0 1px 0 rgba(255, 255, 255, 0.25);

  z-index: 1000;

  writing-mode: vertical-rl;
  text-orientation: mixed;

  font-size: 14px;
  font-weight: 700;
  letter-spacing: 1px;

  backdrop-filter: blur(4px);
}



      `}</style>
        </div>
    );
}

export default IVF;
